module.exports = __webpack_public_path__ + "static/media/article-banner.22500562.png";